import { render } from "./topicList.vue?vue&type=template&id=abe012f4&scoped=true"
import script from "./topicList.vue?vue&type=script&lang=js"
export * from "./topicList.vue?vue&type=script&lang=js"

import "./topicList.vue?vue&type=style&index=0&id=abe012f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe012f4"]])

export default __exports__